import MUITab from "@mui/material/Tab";
import MUITabs from "@mui/material/Tabs";

import InfoIcon from "features/ui/Icons/Info";

import { DEFAULT_TAB } from "./constants";
import { TabsProps } from "./types";
import { getSizeClassName } from "./utils";

const Tabs = ({
  tabs,
  activeTabIndex = DEFAULT_TAB,
  onTabChange,
  tabPanelClassName,
  infoMessage,
  tooltipMessage,
  extraComponent,
  size = "default",
  ...otherTabsProps
}: TabsProps) => {
  const contents = tabs.map(({ content }) => content);
  const currentContent = contents[activeTabIndex ?? DEFAULT_TAB];

  const sizeClass = getSizeClassName(size);

  return (
    <div className="mt-2">
      <MUITabs
        value={activeTabIndex}
        onChange={(_, val) => {
          onTabChange(val);
        }}
        className={sizeClass}
        {...otherTabsProps}
      >
        {tabs.map(
          ({ key, title, testId, disabled = false, disabledText, label }) => {
            const tabTitle = disabled && disabledText ? disabledText : title;

            return (
              <MUITab
                key={key}
                label={label ? label : title}
                disabled={disabled}
                data-testid={testId}
                title={tabTitle}
              />
            );
          }
        )}
        {infoMessage && (
          <div className="flex items-center text-xs gap-2 ml-8 text-gray-400">
            {tooltipMessage && <InfoIcon text={tooltipMessage} />} {infoMessage}
          </div>
        )}
        {extraComponent}
      </MUITabs>
      <div role="tabpanel" className={tabPanelClassName}>
        {currentContent}
      </div>
    </div>
  );
};

export default Tabs;
